<template>
  <cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config" ref="table">
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import {
  getCity,
  add,
  del,
  update,
  getDetails,
  getFinaDivision,
  uploadFile,
  dels,
} from "@/api/system/CustomerCityMapping";
import { getCity as getCity1 } from "@/api/system/city";
import { getCountry } from "@/api/system/country";

import cTable from "@/base/common/index";
export default {
  name: "city",

  components: {
    cTable,
  },
  data() {
    return {
      selectData: {},
      methods: {
        list: getCity,
        getDetails,
        del,
        add,
        update,
        getCountry,
        getFinaDivision,
        uploadFile,
        dels,
      },
      config: {
        height: 630,
      },
      modals: {
        upload: {
          methods: {
            ok() {
              window.open(
                this.$globalUrl + "/doc/zh-CN/client_city.xlsx",
                "_black"
              );
            },
          },
          footer: {
            cancel: {
              isShow: true,
            },
            ok: {
              name: this.$t("download_tem"),
            },
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
              maskClosable: false,
            },
            rowBind: {
              gutter: 16,
              // style: {
              //   marginBottom: "20px"
              // }
            },
            title: this.$t("upload") + this.$t("files"),
          },
          grid: [{ files: 24 }],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx",
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  let _this = this.$refs["table"];
                  _this
                    .handleRequestMethods("uploadFile", formData)
                    .then((res) => {
                      _this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      _this.getModal("upload").close();
                    });
                  return false;
                },
              },
            },
          ],
        },
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              client_city: [
                {
                  required: true,
                  message: "client city cannot be empty",
                  trigger: "blur",
                },
              ],
              country_code: [
                {
                  required: true,
                  message: "Please select the country",
                  trigger: "change",
                },
              ],
              city_id: [
                {
                  required: true,
                  type: "number",
                  message: "Please select the city",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [{ country_code: 24 }, { city_id: 24 }, { client_city: 24 }],
          fields: [
            {
              name: () => this.$t("ClientCityName"),
              key: "client_city",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("ClientCityName");
              },
            },
            {
              name: () => this.$t("countryName"),
              key: "country_code",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("countryName");
              },
              options: [],
              config: { label: "title", value: "code" },
              methods: {
                list: ({ field }) => {
                  field.options = this.selectData[field.key];
                  this.$forceUpdate();
                },
                "on-change": ({ row, fields, field, value }) => {
                  let country = field.options.find((t) => t.code === value);
                  fields.forEach(async (item) => {
                    if (item.key == "city_id") {
                      item.options = (
                        await getCity1({ country_id: country.id })
                      ).data.payload.rows;
                    }
                    this.$forceUpdate();
                  });
                },
              },
            },
            {
              name: () => this.$t("city_name"),
              key: "city_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("city_name");
              },
              options: [],
              config: { label: "title", value: "id" },
            },
          ],
        },
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "country_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("countryName");
            },
            clearable: true,
            options: [],
            config: { label: "title", value: "id" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
              // id: 144,
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: () => this.$tz("批量,导入"),
              type: "import",
              fnName: "import",
              bind: {
                type: "primary",
              },
              id: 1819,
            },
            {
              name: () => this.$tz('批量,删除'),
              type: 'del',
              fnName: 'del',
              bind: {
                type: 'primary'
              },
              disabled() { return !this.selectAll.length }
            },
          ],
          methods: {
            del() {
              this.$Modal.confirm({
                title: this.$tz('删除'),
                width: 300,
                content: this.$t('titleModal'),
                onOk: () => {
                  this.handleRequestMethods('dels', { ids: this.selectAll.map(t => t.id) }, true, true).then(
                    res => {
                      this.getList()
                    }
                  );
                }
              })
            },
            import() {
              this.getModal("upload").open(null, function () {
                this.setTitle(this.$tz("批量,导入"));
              });
            },
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
        },
        {
          name: () => this.$t("ClientCityName"),
          key: "client_city",
          align: "left",
          minWidth: 100,
          tooltip: true,
        },
        {
          name: () => this.$t("city_name"),
          key: "title",
          align: "left",
          minWidth: 100,
          tooltip: true,
        },

        {
          name: () => this.$t("countryCode"),
          key: "country_code",
          minWidth: 100,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          minWidth: 100,
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              // id: 145,
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error",
              },
            },
          ],

          methods: {
            update: ({ row }) => {
              let table = this.$refs["table"];
              table.handleRequestMethods("getDetails", row.id).then((res) => {
                table.getModal("add").setTitle(table.$t("update"));
                table.getModal("add").type = "update";
                let options = this.selectData["country_code"];
                table.getModal("add").open(res.payload, function () {
                  this.fields.forEach(async (item) => {
                    if (item.key == "city_id") {
                      let country = options.find(
                        (t) => t.code === row["country_code"]
                      );
                      console.log(row, country, item);
                      item.options = (
                        await getCity1({ country_id: country.id })
                      ).data.payload.rows;
                    }
                    this.$forceUpdate();
                  });
                  console.log(this);
                  this.fields.forEach(async (item) => {
                    if (item.key == "division") {
                      if (item.key == "division") {
                        item.options = (
                          await this.$page.handleRequestMethods(
                            "getFinaDivision",
                            { country: res.payload.country.code }
                          )
                        ).payload;
                      }
                      this.$forceUpdate();
                    }
                  });
                });
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
  async mounted() {
    this.selectData = {
      country_code: (await getCountry()).data.payload.rows,
      country_id: (await getCountry()).data.payload.rows,
      city_id: (await getCity1()).data.payload.rows,
    };
    this.header.searchs.forEach(async (item) => {
      if (item.key && this.selectData[item.key])
        item.options = this.selectData[item.key];
    });
  },
};
</script>
